export enum SolicitationStatus {
  Concluido = 'Concluído',
  AguardandoValidacaoOperacional = 'Aguardando Validação Operacional',
  AguardandoRevisaoValor = 'Aguardando Revisão de Valor',
  AguardandoGerenteOperacao = 'Aguardando Gerente de Operação',
  ReprovadoValidacaoOperacional = 'Reprovado Validação Operacional',
  ReprovadoCorporativo = 'Reprovado Corporativo',
  EmFechamento = 'Em Fechamento',
}
